import React, { forwardRef } from 'react';
import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { StyledTableCellPrint, StyledTableRow } from '../../reusableComponent/Reusables';
import logo from '../../../images/logo-s.png';
import qa_image from '../../../images/logo-s.png';
import qoiImg from '../../../images/print_header.png';
import styles from '.././../../styles.module.css';

// const DeliveryChallanPrint = forwardRef(({ printDetails }, ref) => {
//     const printData = printDetails;
//     const childRows = printDetails.dc_details;
//     const dateConversion = (date) => {
//         var today = new Date(date);
//         var dd = String(today.getDate()).padStart(2, "0");
//         var mm = String(today.getMonth() + 1).padStart(2, "0");
//         var yyyy = today.getFullYear();
//         const convDate = dd + "/" + mm + "/" + yyyy;
//         return convDate;
//     };

//     return (
//         <>

//             <Box className="print-source" style={{ margin: '30px' }}  >
//                 <Paper sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', height: '90vh', backgroundColor: '#ffffff' }}>
//                     <Grid container sx={{}}>
//                         <Grid item xs={12} style={{
//                             backgroundImage: `url(${qoiImg})`,
//                             backgroundRepeat: 'no-repeat',
//                             backgroundSize: 'cover',
//                             backgroundPosition: 'center',
//                             height: '60px',
//                             marginBottom: '8px'
//                         }}>
//                             <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
//                                 <Typography sx={{ textAlign: 'start', marginLeft: '50px', marginTop: '10px', fontSize: '26px', fontWeight: 'bold', padding: '1px', color: '#ffffff' }}>
//                                     DELIVERY CHALLAN
//                                 </Typography>
//                                 <img src={logo} style={{ width: 'auto', height: '50px', marginTop: '5px', borderRadius: '2px', border: '2px solid #e10a0a' }} />
//                             </Box>
//                         </Grid>
//                         <Grid item xs={12} >
//                             <Grid container>
//                                 <Grid item xs={8} >
//                                     <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
//                                         CYLINDER TRACKING SYSTEM (I) Pvt. Ltd.
//                                     </Typography>
//                                     <Typography sx={{ fontSize: '12px' }}>
//                                         Gat No. 333, xyz xyz, Tal. xyz xyz, xyz - 400 008.
//                                     </Typography>
//                                     <Typography sx={{ fontSize: '12px' }}>
//                                         Email - demotes1234@gmail.com
//                                     </Typography>
//                                     <Typography sx={{ fontSize: '12px' }}>
//                                         Website - www.xyz.com / www.xyz.in
//                                     </Typography>
//                                 </Grid>
//                                 {/* <Grid item xs={4} style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'flex-end',
//                                 }}>
//                                     <img src={qa_image} style={{ width: 'auto', height: '60px', borderRadius: '4px' }} />
//                                 </Grid> */}
//                             </Grid>
//                         </Grid>
//                         <Grid item xs={12} sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', marginTop: '8px' }}>

//                         </Grid>
//                     </Grid>
//                     <Grid container sx={{}}>
//                         <Grid item xs={7} >
//                             <Box sx={{ minHeight: '100px', margin: '6px', marginLeft: '0px', textAlign: 'left', }}>
//                                 <Typography sx={{ fontSize: '18px', fontWeight: 'bold', }}>
//                                     {printData.customer_name}
//                                 </Typography>
//                                 <Typography sx={{ fontSize: '12px', }}>
//                                     {printData.customer_address}
//                                 </Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item xs={5}>
//                             <Grid container >
//                                 <Grid item xs={7} >
//                                     <Box sx={{ minHeight: '100px', margin: '6px', marginRight: '0px', textAlign: 'right' }}>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             DC No
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             DC Date
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             GST No
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             PO No
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             GST Invoice No
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             GST Invoice Date
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             In Time
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             Out Time
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             Vendor Code
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             Pan Code No
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             Vehicle No
//                                         </Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>
//                                             Driver Name
//                                         </Typography>
//                                     </Box >
//                                 </Grid>
//                                 <Grid item xs={0.5} >
//                                     <Box sx={{ textAlign: 'center', margin: '6px', }}>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                         <Typography sx={{ fontSize: '13px' }}>:</Typography>
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={4.5} sx={{ textAlign: 'right' }}>
//                                     <Box sx={{ margin: '6px' }}>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.dc_no}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {dateConversion(printData.dc_date)}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.gst_no}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.po_no}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.gst_invoice_no}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {dateConversion(printData.gst_invoice_date)}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.in_time}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.out_time}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.vendor_code}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.pan_no}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.vehical_no}</Typography>
//                                         <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.driver_name}</Typography>
//                                     </Box>
//                                 </Grid>
//                             </Grid>
//                         </Grid>
//                         <Grid item xs={12} >

//                         </Grid>
//                     </Grid>
//                     <Box style={{ height: '20px' }}> </Box>
//                     <>
//                         <TableContainer sx={{
//                             minWidth: 650,
//                             minHeight: 280,
//                             padding: '0px 1px 0px 1px'
//                         }}>
//                             <Table size="small" style={{ borderCollapse: 'collapse' }}>
//                                 <TableHead>
//                                     <TableRow>
//                                         <StyledTableCellPrint align="center" className={`${styles.print_table_head}`}>Sr No</StyledTableCellPrint>
//                                         <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Product </StyledTableCellPrint>
//                                         <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Product Description</StyledTableCellPrint>
//                                         <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Cylinder No</StyledTableCellPrint>
//                                         <StyledTableCellPrint align="left" className={`${styles.print_table_head}`} >Customer Part Code</StyledTableCellPrint>
//                                     </TableRow>
//                                 </TableHead>
//                                 <TableBody>
//                                     {(childRows && childRows).map((row) => (
//                                         <StyledTableRow>
//                                             <StyledTableCellPrint align="center" className={`${styles.print_table_body}`}>{row.sr_no}</StyledTableCellPrint>
//                                             <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.product}</StyledTableCellPrint>
//                                             <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.product_description}</StyledTableCellPrint>
//                                             <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.cyl_no}</StyledTableCellPrint>
//                                             <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.cust_part_code}</StyledTableCellPrint>
//                                         </StyledTableRow >
//                                     ))}
//                                 </TableBody>
//                             </Table>
//                         </TableContainer>
//                     </>
//                     <br />
//                     <>
//                         <Box style={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', }}>
//                         </Box>
//                         <Box sx={{ textAlign: 'left' }}>
//                             <Grid container >
//                                 <Grid item xs={8} sx={{ minHeight: '130px' }}>
//                                     <Box sx={{ textAlign: 'left', padding: '4px 4px 4px 0px' }}>
//                                         <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
//                                             Terms & Conditions*
//                                         </Typography>

//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={4} >
//                                 </Grid>
//                             </Grid>
//                         </Box>
//                         <Grid container >
//                             <Grid item xs={12} >
//                                 <Box sx={{ padding: '4px 14px 4px 4px', }}>
//                                     <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
//                                         For <span style={{ fontWeight: 'bold' }}> CYLINDER TRACKING SYSTEM (I) Pvt Ltd</span>
//                                     </Typography>
//                                     <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
//                                         XYZ XYZ XYZ (11234567890)
//                                     </Typography>
//                                     <br />
//                                     <br />
//                                     <Typography sx={{ color: '#000000', textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
//                                         Authorized Signatory
//                                     </Typography>
//                                 </Box>
//                             </Grid>
//                         </Grid>
//                     </>
//                 </Paper>

//             </Box >
//         </>
//     );
// });


const DeliveryOrderPrint = forwardRef(({ printDetails }, ref) => {
    const printData = printDetails; // Assuming printDetails contains the updated structure
    // const childRows = printDetails.dc_details || []; 
    const childRows = Array.isArray(printDetails.customer_po_details) ? printDetails.customer_po_details : [];
    const dateConversion = (date) => {
                var today = new Date(date);
                var dd = String(today.getDate()).padStart(2, "0");
                var mm = String(today.getMonth() + 1).padStart(2, "0");
                var yyyy = today.getFullYear();
                const convDate = dd + "/" + mm + "/" + yyyy;
                return convDate;
            };

    return (
        <>
            <Box className="print-source" style={{ margin: '30px' }}>
                <Paper sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', height: '90vh', backgroundColor: '#ffffff' }}>
                    <Grid container>
                        <Grid item xs={12} style={{
                            backgroundImage: `url(${qoiImg})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '60px',
                            marginBottom: '8px'
                        }}>
                            <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                                <Typography sx={{ textAlign: 'start', marginLeft: '50px', marginTop: '10px', fontSize: '26px', fontWeight: 'bold', padding: '1px', color: '#ffffff' }}>
                                    DELIVERY Order
                                </Typography>
                                <img src={logo} style={{ width: 'auto', height: '50px', marginTop: '5px', borderRadius: '2px', border: '2px solid #e10a0a' }} />
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={8}>
                                    <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                                        CYLINDER TRACKING SYSTEM (I) Pvt. Ltd.
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Gat No. 333, xyz xyz, Tal. xyz xyz, xyz - 400 008.
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Email - demotes1234@gmail.com
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px' }}>
                                        Website - www.xyz.com / www.xyz.in
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', marginTop: '8px' }}>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={7}>
                            <Box sx={{ minHeight: '100px', margin: '6px', marginLeft: '0px', textAlign: 'left', }}>
                                <Typography sx={{ fontSize: '18px', fontWeight: 'bold', }}>
                                    {printData.customer_name} {/* Updated field */}
                                </Typography>
                                <Typography sx={{ fontSize: '12px', }}>
                                    {printData.delivery_address} {/* Updated field */}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={5}>
                            <Grid container>
                                <Grid item xs={7}>
                                    <Box sx={{ minHeight: '100px', margin: '6px', marginRight: '0px', textAlign: 'right' }}>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            DC No
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            DC Date
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            GST No
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            PO No
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            GST Invoice No
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            GST Invoice Date
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            In Time
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Out Time
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Vendor Code
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Pan Code No
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Vehicle No
                                        </Typography>
                                        <Typography sx={{ fontSize: '13px' }}>
                                            Driver Name
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={0.5}>
                                    <Box sx={{ textAlign: 'center', margin: '6px', }}>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                        <Typography sx={{ fontSize: '13px' }}>:</Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={4.5} sx={{ textAlign: 'right' }}>
                                    <Box sx={{ margin: '6px' }}>
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.dc_no}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {dateConversion(printData.dc_date)}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.gst_no}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.po_no}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.gst_invoice_no}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {dateConversion(printData.gst_invoice_date)}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.in_time}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.out_time}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.vendor_code}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.pan_no}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.vehical_no}</Typography> {/* Updated field */}
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '13px' }}> {printData.driver_name}</Typography> {/* Updated field */}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box style={{ height: '20px' }}> </Box>
                    <TableContainer sx={{
                        minWidth: 650,
                        minHeight: 280,
                        padding: '0px 1px 0px 1px'
                    }}>
                        <Table size="small" style={{ borderCollapse: 'collapse' }}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCellPrint align="center" className={`${styles.print_table_head}`}>Sr No</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left" className={`${styles.print_table_head}`}>Product</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left" className={`${styles.print_table_head}`}>Product Description</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left" className={`${styles.print_table_head}`}>Cylinder No</StyledTableCellPrint>
                                    <StyledTableCellPrint align="left" className={`${styles.print_table_head}`}>Customer Part Code</StyledTableCellPrint>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(childRows && childRows).map((row) => (
                                    <StyledTableRow key={row.sr_no}>
                                        <StyledTableCellPrint align="center" className={`${styles.print_table_body}`}>{row.sr_no}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.product}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.product_description}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.cyl_no}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.cust_part_code}</StyledTableCellPrint>
                                    </StyledTableRow>
                                ))}
                                 {Array.isArray(childRows) && childRows.map((row) => ( // Check if childRows is an array
                                    <StyledTableRow key={row.sr_no}>
                                        <StyledTableCellPrint align="center" className={`${styles.print_table_body}`}>{row.sr_no}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.product}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.product_description}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.cyl_no}</StyledTableCellPrint>
                                        <StyledTableCellPrint align="left" className={`${styles.print_table_body}`}>{row.cust_part_code}</StyledTableCellPrint>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <br />
                    <Box style={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', minHeight: '10px', }}>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                        <Grid container>
                            <Grid item xs={8} sx={{ minHeight: '130px' }}>
                                <Box sx={{ textAlign: 'left', padding: '4px 4px 4px 0px' }}>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                        Terms & Conditions*
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                            </Grid>
                        </Grid>
                    </Box>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box sx={{ padding: '4px 14px 4px 4px', }}>
                                <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                    For <span style={{ fontWeight: 'bold' }}> CYLINDER TRACKING SYSTEM (I) Pvt Ltd</span>
                                </Typography>
                                <Typography sx={{ textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                    XYZ XYZ XYZ (11234567890)
                                </Typography>
                                <br />
                                <br />
                                <Typography sx={{ color: '#000000', textAlign: 'right', paddingRight: '12px', fontSize: '12px' }}>
                                    Authorized Signatory
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </>
    );
});

export default DeliveryOrderPrint;
